import { useEffect } from 'react';
import style from 'styles/Content.module.scss';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { be, domain, turnstileSiteKey } from 'models/conent';
import axios from 'axios';
import SubscribeSuccess from 'components/_OldDesign/subscribeSuccess';
import { PDPAInfoPayload } from './PDPAConsent/PDPAConsent.model';
import { initialPDPAInfoPayload, PDPAConsent } from './PDPAConsent';
import { Button } from '@components/Common';
import { useLocale } from '@components/Contexts/LocaleContext';
import React from 'react';
import { HoneyPot } from '@components/HoneyPot';
import Turnstile from 'react-cloudflare-turnstile';
import { translate2 } from 'utils/translate';
import { formatRules } from 'utils/validation';

const Subscribe = () => {
  const [email, setEmail] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [pdpaInfo, setPdpaInfo] = useState<PDPAInfoPayload>(null);
  const [pdpaFormValid, setPdpaFormValid] = useState<boolean>(false);
  const { lang } = useLocale();

  const [confirmRecaptcha, setConfirmRecaptcha] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');

  type FormValue = {
    email: string;
    user_code: string;
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValue>();

  useEffect(() => {
    if (recaptchaToken) {
      setConfirmRecaptcha(true);
    } else {
      setConfirmRecaptcha(false);
    }
  }, [recaptchaToken]);

  useEffect(() => {
    const initPdpaInfo = initialPDPAInfoPayload(null, 'News Letter Form');
    setPdpaInfo(initPdpaInfo);
  }, []);

  const handleRecaptchaChange = (token: string) => {
    setRecaptchaToken(token);
  };

  const handleSubmitForm = (data: any, e: any) => {
    e.preventDefault();

    if (data.user_code) {
      return;
    }

    if (!recaptchaToken) {
      alert(
        lang === 'en'
          ? 'Please confirm that you are not a robot.'
          : 'กรุณายืนยันว่าคุณไม่ใช่หุ่นยนต์',
      );
      return;
    }

    submitForm(data, recaptchaToken);
  };

  const submitForm = (data: any, recaptchaToken: string) => {
    //Sent data to strapi
    const form = {
      data: {
        email: data.email,
        recaptcha: recaptchaToken,
      },
      pdpa_info: {
        customer_code: data.email,
        purposes: pdpaInfo.purposes,
      },
    };

    if (window.location.href.includes(domain)) {
      axios
        .post(`${be}/api/news-letter-forms`, form)
        .then((response) => {
          setShowSuccessModal(true);
          const initPdpaInfo = initialPDPAInfoPayload(null, 'News Letter Form');
          setPdpaInfo(initPdpaInfo);
        })
        .finally(() => {
          setRecaptchaToken('');
        });
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 items-center text-white bg-darkBlue m-12 shadow-xl">
      <form
        onSubmit={handleSubmit(handleSubmitForm)}
        className="flex flex-col md:text-left text-center py-20 md:py-8 px-8"
      >
        <p className="mb-6 md:mb-3 leading-relaxed text-gray-300 text-2xl md:text-lg">
          SUBSCRIBE TO OUR
        </p>
        <h1 className="title-font md:text-4xl text-5xl mb-4 font-medium">
          <span className="mb-3 md:mb-1 inline-block">NEWS</span>
          <br />
          <span>LETTER .</span>
        </h1>
        <p className="mb-6 leading-relaxed text-gray-300 text-2xl md:text-lg">
          Code , Consult , Communicate
        </p>
        <input
          type="text"
          className={`${style.outlineNone} bg-transparent border-b w-full border-white px-2 text-white h-20 md:h-12 text-4xl md:text-2xl`}
          placeholder="Email"
          {...register('email', {
            required: {
              value: true,
              message: translate2(
                'กรุณากรอกอีเมลของท่าน',
                'Please enter your email.',
                lang,
              ),
            },
            ...formatRules('email', lang),
          })}
        />
        {errors.email ? (
          <p className="text-red mt-2">{errors.email.message}</p>
        ) : (
          ''
        )}

        {/* Hidden Honeypot Field */}
        <HoneyPot register={register} onChange={() => {}} />

        <div className="text-left my-12 text-xl md:text-sm xl:text-xs">
          <PDPAConsent
            choices={['PP-1', 'PP-2']}
            payload={pdpaInfo}
            setPayload={setPdpaInfo}
            valid={pdpaFormValid}
            setValid={setPdpaFormValid}
            mode={'dark'}
            newDesign={true}
          />
        </div>

        <div className="w-fit mx-auto -mt-4">
          <Turnstile
            turnstileSiteKey={turnstileSiteKey}
            callback={(token) => handleRecaptchaChange(token)}
            theme="light"
          />
        </div>

        {/* <button type="submit" disabled={!pdpaFormValid}
              className="text-dark-blue text-center py-2 px-6 focus:outline-none text-3xl md:text-xl bg-white w-full mt-4 disabled:bg-neutral-300">
                <div className="mt-1">SUBSCRIBE</div>
            </button> */}
        <div className="w-full flex justify-center items-center py-2 mt-4">
          <Button
            type="submit"
            icon="/icons/paper_plane.svg"
            text="ส่งข้อมูล"
            disabled={!pdpaFormValid || !confirmRecaptcha}
            className={`text-xl border border-white disabled:bg-neutral-300`}
          ></Button>
        </div>
      </form>
      <div className="hidden md:block md:w-full md:h-full">
        <img
          className="w-full h-full"
          alt="hero"
          src="/images/bg-subscribe.png"
          style={{ objectFit: 'cover' }}
        />
      </div>
      <SubscribeSuccess
        showModal={showSuccessModal}
        setShowModal={setShowSuccessModal}
      />
    </div>
  );
};

export default Subscribe;
